import React from "react";
import {FormattedMessage} from "react-intl";
import styles from "./index.module.scss";

function TwoBtnPopUp({
  title,
  confirmBtn,
  cancelBtn,
  confirmAction,
  cancelAction,
  dismiss,
}) {
  const onClickConfirm = () => {
    confirmAction && confirmAction();
    dismiss();
  };

  const onClickCancel = () => {
    cancelAction && cancelAction();
    dismiss();
  };

  return (
    <div className={styles.two_btn_popup}>
      <p className={styles.title}>{title}</p>
      <div className={styles.buttons}>
        <button type="button" onClick={onClickCancel}>
          {cancelBtn || <FormattedMessage id="ID_POPUP_BTN_CANCEL" />}
        </button>
        <button
          type="button"
          onClick={onClickConfirm}
          className={styles.confirm_btn}
        >
          {confirmBtn || <FormattedMessage id="ID_POPUP_BTN_CONFIRM" />}
        </button>
      </div>
    </div>
  );
}

export default TwoBtnPopUp;
